import type { ResourceItem } from '@/mocks/resources';

interface ResourceCardProps {
  item: ResourceItem;
  saved: boolean;
  onToggle: (id: string) => void;
}

const ResourceCard = ({ item, saved, onToggle }: ResourceCardProps) => {
  return (
    <article className="res-card relative flex flex-col rounded-lg border border-background-200 bg-background-50 p-4 hover:border-primary-300">
      <div className="flex items-start justify-between">
        <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-100 text-primary-700">
          <i className={`${item.icon} text-xl`} aria-hidden="true" />
        </span>
        <button
          type="button"
          onClick={() => onToggle(item.id)}
          aria-label={saved ? `取消收藏 ${item.name}` : `收藏 ${item.name}`}
          aria-pressed={saved}
          className={`flex h-8 w-8 items-center justify-center rounded-md transition-colors ${
            saved
              ? 'bg-accent-500 text-background-50'
              : 'text-foreground-500 hover:bg-accent-100 hover:text-accent-700'
          }`}
        >
          <i className={saved ? 'ri-bookmark-fill text-lg' : 'ri-bookmark-line text-lg'} aria-hidden="true" />
        </button>
      </div>

      <h3 className="mt-3 text-sm font-bold text-foreground-950 md:text-base">{item.name}</h3>
      <p className="mt-1.5 flex-1 text-xs leading-5 text-foreground-700 md:text-[13px]">{item.desc}</p>

      <div className="mt-3 flex flex-wrap items-center gap-1.5">
        <span className="whitespace-nowrap rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900">
          {item.tag}
        </span>
        <span className="whitespace-nowrap rounded-full border border-background-200 px-2 py-0.5 text-[11px] text-foreground-600">
          {item.extra}
        </span>
      </div>
    </article>
  );
};

export default ResourceCard;